import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const POSIntegration = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        POS Entegrasyonu
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Iyzico, Paytr ve banka API entegrasyonları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default POSIntegration;
